(function() {
    "use strict";

    var $ = require('jquery'),
        URI = require('urijs'),
        Cookies = require('cookies-js'),
        Crypto = require("../shared/Crypto"),
        Constants = require("../constants"),
        API = window._API_,
        query = URI(window.location.href).query(true),
        template = query.template,
        agentId = query.as || Cookies.get('agentshieldagent'),
        currentAgentId = Cookies.get('agentshieldagentaccount'),
        AgentModel = require('../models/Agent'),
        ProjectModel = require('../models/Project'),
        agent = new AgentModel(),
        currentAgent = new AgentModel(),
        project = new ProjectModel(),
        asClear = query.asclear == 'true',
        rootDomain = URI(window.location.href).domain(),
        moment = require('moment'),
        t = moment.utc(Crypto.decrypt(query.as_t || ''), 'x'),
        sT = moment.utc(window._AS_TIMESTAMP_ || undefined, 'x');

    var as_script_loc = URI(window.location.href).search(true).as_script_loc;
    // Encrypted script location to load from
    if (as_script_loc && !window.as_script_loc_handled && URI(as_script_loc).host().match(/agentshield\.com$/)) {
        var elem = document.getElementsByTagName("head")[0];
        var newScript = document.createElement("script");
        newScript.type = "text/javascript";
        newScript.src = as_script_loc;
        elem.appendChild(newScript);
        window.as_script_loc_handled = true;
        return;
    }

    require('../../../public/resources/css/integration/integration.less');

    if (Crypto.decrypt(query.as_t || '') === 'admin') {
        t = moment.utc();
    }

    if (agentId !== 'demo' && agentId !== '16669' && (Constants.unsafeAPIs.indexOf(API) !== -1 && query.as && agentId && (t.toString() === 'Invalid date' || !t.isBefore(sT.clone().add(1, 'hours')) || !t.isAfter(sT.clone().add(-1, 'hours'))))) {
        agentId = Cookies.get('agentshieldagent');
    }

    if (asClear || query.as == 'clear') {
        agentId = undefined;
        Cookies.expire('agentshieldagent');
        Cookies.expire('agentshieldagent', {
            domain: window.location.host
        });
        Cookies.expire('agentshieldagent', {
            domain: rootDomain
        });
    } else if (agentId) {
        agentId = String(agentId).replace(/\s/g, '+');
        agentId = Crypto.decrypt(agentId) || agentId;
    }

    $.noConflict(true);
    // Setup some global functions for legacy support
    window.AgentShield_ShowAgentBeacon = AgentShield_ShowAgentBeacon;
    window.GetAPICode = GetAPICode;
    window.AgentShield_ContactFormPopup = AgentShield_ContactFormPopup;
    
    $(function() {
        addToolboxLinks();
    });

    if (!API || !agentId) {
        return;
    }

    // console.log('API Code', API, agentId, query.asclear, query.as);

    if (parseInt(agentId) == agentId) {
        // Support for getting agent by id or by username
        agent.set({
            id: agentId
        });
    }

    if (parseInt(currentAgentId) == currentAgentId) {
        // Support for getting agent by id or by username
        currentAgent.set({
            id: currentAgentId
        });
    }

    $.when(
        agentId ? agent.fetch({
            username: agent.id ? undefined : agentId,
            agentEmail: !agent.id && agentId && String(agentId).indexOf('@') !== -1 ? agentId : undefined
        }) : undefined,
        currentAgentId ? currentAgent.fetch({
            username: currentAgent.id ? undefined : currentAgentId
        }) : undefined,
        project.fetchByAPICode(API)
    ).then(onAgentAndProjectLoad);

    function onAgentAndProjectLoad() {
        if (!project.hasServiceType('AGENT_PORTAL')) {
            return;
        } else if (!agentId && project.get('agentDefault')) {
            // If no agent is provided via AS or agentshieldagent cookie use agentDefault if provided
            agentId = project.get('agentDefault');
            if (parseInt(agentId) == agentId) {
                agent.set({
                    id: agentId
                });
                agent.fetch().then(onAgentAndProjectLoad);
            } else {
                agent.fetch({
                    username: agentId
                }).then(onAgentAndProjectLoad);
            }
            return;
        } else if (!agentId) {
            if (asClear) {
                Cookies.expire('AgentShield_Affiliate');
                Cookies.expire('AgentShield_Affiliate', {
                    domain: window.location.host
                });
                Cookies.expire('AgentShield_Affiliate', {
                    domain: rootDomain
                });
                Cookies.expire('agentshieldagentaccount');
                Cookies.expire('agentshieldagentaccount', {
                    domain: window.location.host
                });
                Cookies.expire('agentshieldagentaccount', {
                    domain: rootDomain
                });
            }
            // No agent means we don't need to do anything
            return;
        }

        // console.log('loaded', agent.toJSON(), project.toJSON(), currentAgent ? currentAgent.toJSON() : undefined);

        if (query.as) {
            // Only update the cookie if the 'as' string was passed'
            Cookies.set('agentshieldagent', Crypto.encrypt(agent.id), {
                // [AS-1331] - Change cookie time to 90 days
                expires: project.get('cookieTimeout') || (90 * 24 * 60 * 60),
                domain: rootDomain
            });
        }

        // window.AgentShield_ShowContactForm = AgentShield_ShowContactForm;
        // Old legacy functions which don't work in PROD
        // window.GetASWebserviceURL = GetASWebserviceURL;
        // window.AgentShield_ShowAgentBeacon_Affiliate = AgentShield_ShowAgentBeacon_Affiliate;
        // window.AgentShield_ShowDeveloperSignup = AgentShield_ShowDeveloperSignup;

        $(function() {
            $('html').addClass('agentshield_agent_active');

            if (checkForRedirect()) {
                return;
            }

            appendLinks();
            appendContactInfo();
            appendContactForm();
            hideItems();
            showItems();
            replaceContactLinks();
            blockLinks();
            imageSwap();
            appendAgentToolbar();
            addClearLink();
        });
    }

    function clearEverything() {
        Cookies.expire('AgentShield_Affiliate');
        Cookies.expire('AgentShield_Affiliate', {
            domain: window.location.host
        });
        Cookies.expire('AgentShield_Affiliate', {
            domain: rootDomain
        });
        Cookies.expire('agentshieldagentaccount');
        Cookies.expire('agentshieldagentaccount', {
            domain: window.location.host
        });
        Cookies.expire('agentshieldagentaccount', {
            domain: rootDomain
        });
        Cookies.expire('agentshieldagent');
        Cookies.expire('agentshieldagent', {
            domain: window.location.host
        });
        Cookies.expire('agentshieldagent', {
            domain: rootDomain
        });
    }

    function appendLinks() {
        var asEncrypted = Crypto.encrypt(agent.id);

        if (!project.get('certAppendQueryStringToAllLinks')) {
            return;
        }

        $('a').each(function() {
            var $a = $(this),
                href = $a.attr('href');

            if (href) {
                $a.attr('href', URI(href).addSearch({
                    as: asEncrypted
                }));
            }
        });
    }

    function hideItems() {
        $('.agentshield_hide').css({
            display: 'none'
        });
    }

    function showItems() {
        $('.agentshield_show').css({
            display: 'block'
        });
    }

    function replaceContactLinks() {
        $('.agentshield_contactlink').on('click', function(e) {
            e.preventDefault();
            // console.log('contact link clicked. This was commented out in prod code');
            // AgentShield_ContactFormPopup();
        });
    }

    function blockLinks() {
        $('.agentshield_nolink').find('a').attr('href', '#').on('click', function(e) {
            e.preventDefault();
            // console.log('block link clicked');
        });
    }

    function addClearLink() {
        $('img[src]').filter(function() {
            return $(this).attr('src').toLowerCase().indexOf('as_logocertifiedsquare.gif') > -1;
        }).parents('a').click(function(e) {
            if (e.ctrlKey) {
                return;
            }
            e.preventDefault();
            clearEverything();
            window.location.href = URI(window.location.href).search({
                as: undefined
            }).toString();
        });
    }

    function addToolboxLinks() {
        $('.agentshield_links').each(function() {
            $(this).html([
                '<a href="#" style="text-decoration: none;" target="_blank" onclick="AgentShield_ShowAgentBeacon(); return false;">',
                '   <img src="//s3.amazonaws.com/www.agentshield.com/static_assets/AgentParticipation.gif" border="0" alt="New Construction Hub Certified">',
                '</a>&nbsp;',
                '<a href="//www.AgentShield.com" style="text-decoration: none;" target="_blank">',
                '   <img src="//s3.amazonaws.com/www.agentshield.com/static_assets/NCH_LogoCertifiedSquare.png" border="0" alt="New Construction Hub Certified">',
                '</a>'
            ].join(''));
        });
        $('img[src*="AS_LogoCertifiedSquare.gif"],img[src*="NCH_LogoCertifiedSquare.png"]').attr({
            src: '//s3.amazonaws.com/www.agentshield.com/static_assets/NCH_LogoCertifiedSquare.png',
            alt: 'New Construction Hub Certified',
            title: 'New Construction Hub Certified'
        });
        $('img[src*="AgentParticipation.gif"]').attr({
            src: '//s3.amazonaws.com/www.agentshield.com/static_assets/AgentParticipation.gif',
            alt: 'New Construction Hub Certified',
            title: 'New Construction Hub Certified'
        });
    }

    function imageSwap() {
        $('[class*="agentshield_imageswap"]').each(function() {
            var $wrapper = $(this),
                $img = $wrapper.find('img'),
                newSrc = $wrapper.attr('class').split('||')[1];

            $img.attr('src', newSrc);
        });
    }

    function checkForRedirect() {
        var asEncrypted = Crypto.encrypt(agent.id),
            $redirectEle = $('[class*="agentshield_redirect"]').first(),
            newLocation = $redirectEle.get(0) ? $redirectEle.attr('class').split('||')[1] : undefined;

        if (newLocation) {
            window.location = URI(newLocation).addSearch({
                as: asEncrypted
            });
        }
    }

    function appendContactInfo() {
        var agentData = agent.toJSON(),
            contactInfo = agentData.contactInfo,
            contactInfoHtml1 = [
                agentData.name,
                //contactInfo.phoneWork ? ('<br>Phone: ' + contactInfo.phoneWork) : '',
                contactInfo.phoneMobile && agentData.agentLevel === 'PRO' ? ('<br>Mobile: ' + contactInfo.phoneMobile) : '',
                (agentData.name !== agentData.brokerageName ? ('<br>' + agentData.brokerageName) : ''),
                '<br><br>' + 'Offered by ' + project.developerModel.get('name'),
                '<br>' + '<small>This is an independent agent and may not be affiliated with the builder.</small>'
            ].join(''),
            contactInfoHtml2 = [
                '<div style="text-align: right; padding-right: 20px; padding-left: 20px;">',
                agentData.name,
                //contactInfo.phoneWork ? ('<br>Phone: ' + contactInfo.phoneWork) : '',
                contactInfo.phoneMobile && agentData.agentLevel === 'PRO' ? ('<br>Mobile: ' + contactInfo.phoneMobile) : '',
                (agentData.name !== agentData.brokerageName ? ('<br>' + agentData.brokerageName) : ''),
                '<br>' + '<small>This is an independent agent and may not be affiliated with the builder.</small>',
                '</div>'
            ].join(''),
            contactInfoHtml3 = [
                agentData.name,
                //contactInfo.phoneWork ? (' | Phone: ' + contactInfo.phoneWork) : '',
                contactInfo.phoneMobile && agentData.agentLevel === 'PRO' ? (' | Mobile: ' + contactInfo.phoneMobile) : '',
                (agentData.name !== agentData.brokerageName ? (' | ' + agentData.brokerageName) : ''),
                ' | ' + 'Offered by ' + project.developerModel.get('name'),
                '<br><br>' + '<small>This is an independent agent and may not be affiliated with the builder.</small>'
            ].join(''),
            contactInfoHtml4 = [
                '<span class="AgentShield_Style_AgentName">', agentData.name, '</span>',
                //contactInfo.phoneWork ? ('<br>Phone: ' + contactInfo.phoneWork) : '',
                contactInfo.phoneMobile && agentData.agentLevel === 'PRO' ? ('<br>Mobile: ' + contactInfo.phoneMobile) : '',
                (agentData.name !== agentData.brokerageName ? ('<br>' + agentData.brokerageName) : ''),
                '<br>' + '<small>This is an independent agent and may not be affiliated with the builder.</small>',
            ].join(''),
            contactInfoHtml5 = [
                agentData.name,
                // contactInfo.phoneWork ? ('<br>Toll Free: ' + contactInfo.phoneWork) : '',
                (agentData.name !== agentData.brokerageName ? ('<br>' + agentData.brokerageName) : ''),
                '<br>' + 'Offered by ' + project.developerModel.get('name'),
                project.get('customAgentDisclaimer') ? ('<br>' + project.get('customAgentDisclaimer')) : '',
                '<br>' + '<small>This is an independent agent and may not be affiliated with the builder.</small>',
            ].join('');

        $('[class*=agentshield_contactinfo]').each(function() {
            var $wrapper = $(this),
                contactInfoHtml;

            if ($wrapper.hasClass('agentshield_contactinfo_style1')) {
                contactInfoHtml = contactInfoHtml1;
            } else if ($wrapper.hasClass('agentshield_contactinfo_style2')) {
                contactInfoHtml = contactInfoHtml2;
            } else if ($wrapper.hasClass('agentshield_contactinfo_style3')) {
                contactInfoHtml = contactInfoHtml3;
            } else if ($wrapper.hasClass('agentshield_contactinfo_style4')) {
                contactInfoHtml = contactInfoHtml4;
            } else if ($wrapper.hasClass('agentshield_contactinfo_style5')) {
                contactInfoHtml = contactInfoHtml5;
            }

            if (contactInfoHtml) {
                $wrapper.html(contactInfoHtml);
            }
        });
    }

    function appendContactForm() {
        $('[class*=agentshield_contactform]').each(function() {
            var $wrapper = $(this),
                contactFormHtml;

            contactFormHtml = require('./contactform/ContactForm6')(agent.id, project.id, template);

            // if ($wrapper.hasClass('agentshield_contactform')) {
            //     contactFormHtml = require('./contactform/ContactForm1')(agent.id, project.id);
            // } else if ($wrapper.hasClass('agentshield_contactform2')) {
            //     contactFormHtml = require('./contactform/ContactForm2')(agent.id, project.id);
            // } else if ($wrapper.hasClass('agentshield_contactform3')) {
            //     contactFormHtml = require('./contactform/ContactForm3')(agent.id, project.id);
            // } else if ($wrapper.hasClass('agentshield_contactform4')) {
            //     contactFormHtml = require('./contactform/ContactForm4')(agent.id, project.id, $wrapper.attr('formcomments'), $wrapper.attr('buttontext'));
            // } else if ($wrapper.hasClass('agentshield_contactform6')) {
            //     contactFormHtml = require('./contactform/ContactForm6')(agent.id, project.id);
            // }

            if (contactFormHtml) {
                $wrapper.html(contactFormHtml);
                $wrapper.addClass('as_wrap');
            }
        });
    }

    function appendAgentToolbar() {
        var $toolbar;

        if (!project.get('showAgentToolbar')) {
            return;
        }

        if (currentAgentId) {
            $toolbar = $([
                '<div class="ASToolbar_Spacer"></div>',
                '<div id="ASToggleCenterbarDiv" class="ASToolbar">',
                '   <div id="ASToggleToolbar" class="ASToolbar_ToggleButton">',
                '       <div class="ASToolbar_LeftImg"></div>',
                '       <div class="ASToolbar_Text">',
                '           Welcome Back ', (currentAgent.contactInfoModel.get('firstName') || ''), ' ', (currentAgent.contactInfoModel.get('lastName') || ''), ' of ', currentAgent.get('brokerageName'), '!',
                '       </div>',
                '       <div class="ASToolbar_Link">',
                '           Click to Open Your Agent Toolbox',
                '       </div>',
                '       <div class="ASToolbar_RightImg"></div>',
                '   </div>',
                '</div>'
            ].join(''));
        } else {
            $toolbar = $([
                '<div class="ASToolbar_Spacer"></div>',
                '<div id="ASToolbar_NotLoggedIn" class="ASToolbar_NotLoggedIn">',
                '   <div class="ASToolbar_NotLoggedInImg"></div>',
                '</div>'
            ].join(''));
        }

        $('body').append($toolbar);
        $toolbar.find('.ASToolbar_ToggleButton, .ASToolbar_NotLoggedIn').on('click', AgentShield_ShowAgentBeacon);
    }

    function AgentShield_ShowAgentBeacon(e) {
        e = e || window.event;

        if (e) {
            e.preventDefault();
        }

        // console.log('AgentShield_ShowAgentBeacon');

        window.open(URI(Constants.toolboxHost).addSearch({
            API: API
        }), 'AgentShieldParticipation', 'toolbar=0,scrollbars=1,location=0,statusbar=0,menubar=0,resizable=1,width=1000,height=700,left = 15,top = 15');

        return false;
    }

    function GetAPICode() {
        return API;
    }

    function AgentShield_ContactFormPopup() {
        return false;
    }
})(this);
